import axios from 'axios'
import * as Sentry from '@sentry/react';

export const axiosSetup = () => {
    axios.interceptors.response.use(
        (res) => res,
        (error) => {
            const details = {
                message: error?.message,
                code: error?.code,
                url: error.config?.url,
                method: error.config?.method,
                params: error.config?.params,
                body: error.config?.data,
                status: error.response?.status,
                response: error.response?.data,
                headers: error.response?.headers
            }
            console.error(`Axios error interceptor ${details.url} : ${details.code} : ${details.message}`, details)
            Sentry.captureException(error, {
                extra: details
            });

            return Promise.reject(error);
        }
    );
}